import Vue from 'vue';
import VueToasted from 'vue-toasted';

Vue.use(VueToasted, {
  position: 'bottom-left',
  duration: 1500
});